// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__fL2Pl","title":"Header_title__joRc3","side":"Header_side__3EdJo"};